export default "__VITE_ASSET__B_KHpwF0__"